module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074bf_banner_800x600.19057b6c.png";